import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { IRemoteAgentService } from 'vscode/vscode/vs/workbench/services/remote/common/remoteAgentService.service';
import { RemoteAgentService } from './vscode/src/vs/workbench/services/remote/browser/remoteAgentService.js';
import { RemoteSocketFactoryService } from './vscode/src/vs/platform/remote/common/remoteSocketFactoryService.js';
import { IRemoteSocketFactoryService } from 'vscode/vscode/vs/platform/remote/common/remoteSocketFactoryService.service';
import { IRemoteAuthorityResolverService } from 'vscode/vscode/vs/platform/remote/common/remoteAuthorityResolver.service';
import { RemoteAuthorityResolverService } from './vscode/src/vs/platform/remote/browser/remoteAuthorityResolverService.js';
import { BrowserSocketFactory } from './vscode/src/vs/platform/remote/browser/browserSocketFactory.js';
import { RemoteFileSystemProviderClient } from './vscode/src/vs/workbench/services/remote/common/remoteFileSystemProviderClient.js';
import { IBrowserWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/browser/environmentService.service';
import { IFileService } from 'vscode/vscode/vs/platform/files/common/files.service';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';
import { RemoteExplorerService } from 'vscode/vscode/vs/workbench/services/remote/common/remoteExplorerService';
import { IRemoteExplorerService } from 'vscode/vscode/vs/workbench/services/remote/common/remoteExplorerService.service';
import { ExternalUriOpenerService } from 'vscode/vscode/vs/workbench/contrib/externalUriOpener/common/externalUriOpenerService';
import { IExternalUriOpenerService } from 'vscode/vscode/vs/workbench/contrib/externalUriOpener/common/externalUriOpenerService.service';
import { RemoteExtensionsScannerService } from './vscode/src/vs/workbench/services/remote/common/remoteExtensionsScanner.js';
import { IRemoteExtensionsScannerService } from 'vscode/vscode/vs/platform/remote/common/remoteExtensionsScanner.service';
import { IProductService } from 'vscode/vscode/vs/platform/product/common/productService.service';
import { IEnvironmentService } from 'vscode/vscode/vs/platform/environment/common/environment.service';
import { BrowserRemoteResourceLoader } from './vscode/src/vs/workbench/services/remote/browser/browserRemoteResourceHandler.js';
import { IWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/common/environmentService.service';
import { IRemoteUserDataProfilesService } from 'vscode/vscode/vs/workbench/services/userDataProfile/common/remoteUserDataProfiles.service';
import { IUserDataProfileService } from 'vscode/vscode/vs/workbench/services/userDataProfile/common/userDataProfile.service';
import { IActiveLanguagePackService } from 'vscode/vscode/vs/workbench/services/localization/common/locale.service';
import { ITunnelService } from 'vscode/vscode/vs/platform/tunnel/common/tunnel.service';
import { TunnelService } from './vscode/src/vs/workbench/services/tunnel/browser/tunnelService.js';
import getServiceOverride$1 from '@codingame/monaco-vscode-environment-service-override';
import { getWorkbenchConstructionOptions } from 'vscode/workbench';
import { registerServiceInitializePreParticipant } from 'vscode/lifecycle';
import './vscode/src/vs/workbench/contrib/remote/common/remote.contribution.js';
import './vscode/src/vs/workbench/contrib/remote/browser/remote.contribution.js';
import './vscode/src/vs/workbench/contrib/remote/browser/remoteStartEntry.contribution.js';

let CustomRemoteSocketFactoryService = class CustomRemoteSocketFactoryService extends RemoteSocketFactoryService {
    constructor(browserWorkbenchEnvironmentService) {
        super();
        this.register(0 , new BrowserSocketFactory(browserWorkbenchEnvironmentService.options?.webSocketFactory));
    }
};
CustomRemoteSocketFactoryService = __decorate([
    ( __param(0, IBrowserWorkbenchEnvironmentService))
], CustomRemoteSocketFactoryService);
let InjectedRemoteAuthorityResolverService = class InjectedRemoteAuthorityResolverService extends RemoteAuthorityResolverService {
    constructor(environmentService, productService, logService, fileService) {
        const configuration = getWorkbenchConstructionOptions();
        const connectionToken = environmentService.options.connectionToken;
        const remoteResourceLoader = configuration.remoteResourceProvider != null ? new BrowserRemoteResourceLoader(fileService, configuration.remoteResourceProvider) : undefined;
        const resourceUriProvider = configuration.resourceUriProvider ?? remoteResourceLoader?.getResourceUriProvider();
        super(!environmentService.expectsResolverExtension, connectionToken, resourceUriProvider, configuration.serverBasePath, productService, logService);
    }
};
InjectedRemoteAuthorityResolverService = __decorate([
    ( __param(0, IEnvironmentService)),
    ( __param(1, IProductService)),
    ( __param(2, ILogService)),
    ( __param(3, IFileService))
], InjectedRemoteAuthorityResolverService);
let CustomRemoteExtensionsScannerService = class CustomRemoteExtensionsScannerService extends RemoteExtensionsScannerService {
    constructor(scanRemoteExtensions, remoteAgentService, environmentService, userDataProfileService, remoteUserDataProfilesService, logService, activeLanguagePackService) {
        super(remoteAgentService, environmentService, userDataProfileService, remoteUserDataProfilesService, logService, activeLanguagePackService);
        this.scanRemoteExtensions = scanRemoteExtensions;
    }
    async scanExtensions() {
        if (!this.scanRemoteExtensions) {
            return [];
        }
        return super.scanExtensions();
    }
};
CustomRemoteExtensionsScannerService = __decorate([
    ( __param(1, IRemoteAgentService)),
    ( __param(2, IWorkbenchEnvironmentService)),
    ( __param(3, IUserDataProfileService)),
    ( __param(4, IRemoteUserDataProfilesService)),
    ( __param(5, ILogService)),
    ( __param(6, IActiveLanguagePackService))
], CustomRemoteExtensionsScannerService);
registerServiceInitializePreParticipant(async (serviceAccessor) => {
    RemoteFileSystemProviderClient.register(serviceAccessor.get(IRemoteAgentService), serviceAccessor.get(IFileService), serviceAccessor.get(ILogService));
});
function getServiceOverride({ scanRemoteExtensions = false } = {}) {
    return {
        ...getServiceOverride$1(),
        [( IRemoteAgentService.toString())]: new SyncDescriptor(RemoteAgentService, [], true),
        [( IRemoteSocketFactoryService.toString())]: new SyncDescriptor(CustomRemoteSocketFactoryService, [], true),
        [( IRemoteAuthorityResolverService.toString())]: new SyncDescriptor(InjectedRemoteAuthorityResolverService, []),
        [( IRemoteExplorerService.toString())]: new SyncDescriptor(RemoteExplorerService, [], true),
        [( IExternalUriOpenerService.toString())]: new SyncDescriptor(ExternalUriOpenerService, [], true),
        [( IRemoteExtensionsScannerService.toString())]: new SyncDescriptor(CustomRemoteExtensionsScannerService, [scanRemoteExtensions], true),
        [( ITunnelService.toString())]: new SyncDescriptor(TunnelService, [], true)
    };
}

export { getServiceOverride as default };
